// MapComponent.tsx
import { gridSizeMdLg4, gridSizeMdLg8 } from "@/shared";
import { useUpdateFlota } from "@/shared/actions/erp";
import { LoaderComponent } from "@/shared/components/ui";
import PolygonLayer from "@/shared/components/ui/PolygonLayer/PolygonLayer";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { Delete } from "@mui/icons-material";
import { Button, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import "leaflet/dist/leaflet.css";
import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import { useAsignarZonaFlota } from "../../store";
import "./CustomMapFlota.css";

const ChangeMapView: React.FC<{ center: [number, number] }> = ({ center }) => {
  const map = useMap();

  React.useEffect(() => {
    if (map) {
      map.setView(center, map.getZoom());
    }
  }, [center, map]);

  return null;
};

interface CustomMapFlotaProps {
  esModal: boolean;
}

const CustomMapFlota: React.FC<CustomMapFlotaProps> = ({ esModal = false }) => {
  const [centerMap, setCenterMap] = useState<[number, number]>([
    -0.3208730168341767, -78.47201823285198,
  ]);

  const {
    flotaSelect,
    zones: zonesPagingRes,
    isLoadingZone,
    listaZonas,
    setListaZonas,
  } = useAsignarZonaFlota();

  const { mutateAsync } = useUpdateFlota({});

  const setAlert = useUiStore((s) => s.setAlert);

  if (isLoadingZone) return <LoaderComponent />;

  useEffect(() => {
    if (
      !isLoadingZone &&
      listaZonas.at(0)?.coordenadas_array != null &&
      listaZonas.length != 0
    ) {
      setCenterMap([
        +listaZonas.at(0)?.coordenadas_array?.at(0)?.lat!,
        +listaZonas.at(0)?.coordenadas_array?.at(0)?.lng!,
      ]);
    }
  }, []);

  return (
    <Grid container spacing={2}>
      <Grid item {...gridSizeMdLg4}>
        <Grid
          container
          spacing={1}
          justifyContent={"center"}
          sx={{
            border: "1px solid #E8E8E8",
            borderRadius: "8px",
            padding: "10px 5px",
          }}
        >
          <Grid item xs={12}>
            <Typography variant="subtitle1">Zonas:</Typography>
          </Grid>

          {listaZonas.length === 0 && (
            <Grid item xs={12}>
              <Typography variant="subtitle1">
                Asigna una o varias zonas a la flota.
              </Typography>
            </Grid>
          )}

          {listaZonas.map((value) => (
            <Grid item xs={12} key={value.id_zona}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Tooltip title="Eliminar Zona">
                  <IconButton
                    onClick={() => {
                      const filter = listaZonas.filter(
                        (e) => e.id_zona != value.id_zona,
                      );
                      setListaZonas(filter);
                    }}
                  >
                    <Delete color="error" />
                  </IconButton>
                </Tooltip>
                <Typography variant="body2">{value.nombre}</Typography>
              </div>
            </Grid>
          ))}

          {esModal && flotaSelect?.id_flota && (
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="outlined"
                onClick={async () => {
                  if (listaZonas.length === 0)
                    return setAlert(
                      true,
                      "Asignar Zonas",
                      AlertSeverityEnum.info,
                    );

                  await mutateAsync({
                    id: flotaSelect.id_flota!,
                    data: {
                      //...flotaSelect,
                      bodega: flotaSelect.bodega,
                      es_bodega: flotaSelect.es_bodega,
                      ubicacion: flotaSelect.ubicacion,
                      zona: listaZonas.at(0)?.codigo,
                      zonas: listaZonas?.map((zona) => zona.codigo),
                    } as any,
                  });
                }}
              >
                Guardar Cambios
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>

      <Grid item {...gridSizeMdLg8}>
        <MapContainer
          center={[0, 0]}
          zoom={11}
          style={{ height: "70vh", width: "100%" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          />
          <PolygonLayer
            isLeafletPopup={true}
            zones={zonesPagingRes ?? []}
            handleClick={(polygon) => {
              const existe = listaZonas.find(
                (e) => e.id_zona == polygon.id_zona,
              );
              if (existe)
                return setAlert(
                  true,
                  "Zona ya fue asignada",
                  AlertSeverityEnum.info,
                );
              setListaZonas([...listaZonas, polygon]);
            }}
          />

          <ChangeMapView center={centerMap} />
        </MapContainer>
      </Grid>
    </Grid>
  );
};

export default CustomMapFlota;
